import { render, staticRenderFns } from "./Characteristic.vue?vue&type=template&id=3ee81bf8&scoped=true"
import script from "./Characteristic.vue?vue&type=script&lang=js"
export * from "./Characteristic.vue?vue&type=script&lang=js"
import style0 from "./Characteristic.vue?vue&type=style&index=0&id=3ee81bf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee81bf8",
  null
  
)

export default component.exports